import React from 'react'
import { AppSelectionBar, AppSelectionBarButton } from "@components"
import { useGlobalBatchMultiple } from "Pages/Admin/GlobalExecution/Batches/@hooks"


export default function GlobalExecutionToolbarSelect({ selectedData, setSelectedRows }) {

	const { handleStopMultipleExecutions, handleRetryMultipleExecutions } = useGlobalBatchMultiple(selectedData, setSelectedRows)

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton icon="circle-stop" label="Stop" title="Stop multiple executions" onClick={handleStopMultipleExecutions}/>
		<AppSelectionBarButton icon="rotate-right" label="Retry" title="Retry multiple executions" onClick={handleRetryMultipleExecutions}/>
	</AppSelectionBar>
}